module.exports = __webpack_public_path__ + "img/legume-peanuts-350x184.7101e4ac.jpg";